import { useContext } from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Tab, Tooltip } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSelector } from 'src/reducers';
import { MoreMenu, DataGridRender } from 'src/components/table';
import MessageContext from 'src/context/MessageContext';
import TabLayout from 'src/components/tab/TabLayout';
import TopBar from 'src/components/shared/TopBar';
import { MessageAllRequest, MessageDeleteRequest } from 'src/actions/messageActions';


export default function MessageList() {

  const { setMessageHandler } = useContext<any>(MessageContext);
  const [pageNo, setPageNo] = useState(1);
  const [limit, setLimit] = useState(10);
  const [status] = useState(false);
  const [filters, setFilters] = useState<any>([]);
  const [search, setSearch] = useState<string>('');

  const dispatch = useDispatch();
  const { loading, metadata, messages } = useSelector(state => state.message);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(MessageAllRequest(filters, search, pageNo, limit, status));
  }, [pageNo, search, limit, status, filters]);

  const deleteAction = (id: string) => {
    dispatch(MessageDeleteRequest(id, { isDeleted: true }, setMessageHandler));
  }
  const editAction = (id: string) => {
    navigate(`/admin/library/message/${id}/edit`);
  }

  const columns = [
    { field: 'type', type: "string", headerName: 'Type', filterable: false, headerAlign: "center", align: 'center', width: 100 },
    { field: 'module', type: "string", headerName: 'Module', filterable: false, headerAlign: "center", align: 'center', width: 100 },
    { field: 'title', type: "string", headerName: 'Title', filterable: false, headerAlign: "center", align: 'center', width: 200 },
    { field: 'body', type: "string", headerName: 'Body', filterable: false, headerAlign: "left", align: 'left', flex: 1, renderCell: ({  value }: any) => {
        return <Tooltip title={value}>
          <Typography variant="subtitle2">{value}</Typography>
        </Tooltip>
      }
    },
    { field: 'actions', headerName: '', width: 100, headerAlign: "right", align: 'right', type: 'actions', getActions: ({ id, row }: any) => [<MoreMenu id={id} name={row['categoryTitle']} cloneAction="" addAction='' editAction={editAction} deleteAction={deleteAction} exportAction="" />] },
  ];


  return (
    <Container maxWidth={false}>
      <TopBar title="Library" link="/admin/library/message/add" buttonText="Add Message" />
      <TabLayout handleChange="" tabValue={5}>
        <Tab label="Categories" onClick={() => navigate("/admin/library")} value={1} />
        <Tab label="Questions" onClick={() => navigate("/admin/library/question")} value={2} />
        <Tab label="Supplier Rules" onClick={() => navigate("/admin/library/rule")} value={3} />
        <Tab label="Qualfications" onClick={() => navigate("/admin/library/qualification")} value={4} />
        <Tab label="Message" onClick={() => navigate("/admin/library/message")} value={5} />
      </TabLayout>
      <DataGridRender
        loading={loading}
        filterTypes={['status', 'search', 'export']}
        exportFileName={"Messages"}
        data={messages}
        metadata={metadata}
        limit={limit}
        search={search}
        filters={filters}
        pageNo={pageNo}
        columns={columns}
        setPageNo={setPageNo}
        setSearch={setSearch}
        setLimit={setLimit}
        setFilters={setFilters}
      />
    </Container>
  );
}
